<div id="typing-container"></div>